import React from "react";
import { NavLink } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ReCAPTCHA from "react-google-recaptcha";
import SocialAuth from "./social-auth";

const LoginForm = (props) => {
  const {
    validationSchema,
    userLoginadata,
    inputChange,
    showpassword,
    setShowPassword,
    changeicon,
    setChangeicon,
    lockCooldown,
    suspendedError,
    handleGoogleSignup,
    handleMicrosoftSignup,
    isSocialLoading,
    setCaptchaToken,
  } = props;

  const recaptchaSiteKey =
    process.env.REACT_APP_RECAPTCHA_SITE_KEY ||
    "6LdYeqEtAAAAAOXqO51kadrNpd7eU4rsVlgxAR9y";

  return (
    <Formik
      initialValues={{ emailorphone: "", password: "", captchaToken: "" }}
      validateOnBlur={true}
      validationSchema={validationSchema}
      onSubmit={() => {
        /* handled by form submit handler */
      }}
    >
      {({
        handleChange,
        handleBlur,
        handleSubmit,
        errors,
        touched,
        isValid,
        dirty,
        setFieldValue,
        setFieldTouched,
      }) => (
        <Form
          onSubmit={(e) => {
            userLoginadata(e);
            handleSubmit(e);
          }}
        >
          <label htmlFor="emailorphone" className="form-label labelSize">
            Email address or Phone number*
          </label>
          <Field
            type="text"
            className="form-control box-height inputSizing"
            id="emailorphone"
            name="emailorphone"
            placeholder="Email address or Phone number"
            aria-describedby="emailHelp"
            onChange={(e) => {
              inputChange(e);
              handleChange(e);
            }}
            onBlur={handleBlur}
          />
          {errors.emailorphone && touched.emailorphone ? (
            <div>
              <p className="error_text_color">{errors.emailorphone}</p>
            </div>
          ) : null}

          <div className=" mt-2">
            <label htmlFor="password" className="form-label labelSize">
              Password*
            </label>
            <InputGroup className=" eyeset form-control box-height inputSizing">
              <Field
                type={showpassword}
                className="border-0 password-width"
                placeholder="Enter password"
                id="password"
                name="password"
                onChange={(e) => {
                  inputChange(e);
                  handleChange(e);
                }}
                onBlur={handleBlur}
              />
              {changeicon === 1 && (
                <VisibilityIcon
                  className="cursor_P"
                  onClick={() => {
                    setShowPassword("text");
                    setChangeicon(2);
                  }}
                />
              )}
              {changeicon === 2 && (
                <VisibilityOffIcon
                  className="cursor_P"
                  onClick={() => {
                    setShowPassword("password");
                    setChangeicon(1);
                  }}
                />
              )}
            </InputGroup>
          </div>

          {errors.password && touched.password ? (
            <div>
              <p className="error_text_color">{errors.password}</p>
            </div>
          ) : null}

          {lockCooldown > 0 && (
            <div
              className="alert alert-danger mt-3 text-center border-0 rounded-3 py-2 px-3 d-flex align-items-center justify-content-center gap-2"
              style={{
                backgroundColor: "#ffeef0",
                color: "#ff3366",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              <span
                className="spinner-grow spinner-grow-sm text-danger"
                role="status"
                aria-hidden="true"
                style={{ width: "10px", height: "10px" }}
              ></span>
              <span>
                Account temporarily locked. Please try again in{" "}
                <strong>{lockCooldown}s</strong>
              </span>
            </div>
          )}

          {suspendedError && (
            <div
              className="alert alert-danger mt-3 text-center border-0 rounded-3 py-2 px-3 d-flex align-items-center justify-content-center gap-2"
              style={{
                backgroundColor: "#ffeef0",
                color: "#ff3366",
                fontSize: "14px",
                fontWeight: "600",
                border: "1px solid #ffccd5",
              }}
              role="alert"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
                className="flex-shrink-0"
              >
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.646-2.646a.5.5 0 0 0-.708 0L5.354 10.646a.5.5 0 0 0 .708.708l5.292-5.292a.5.5 0 0 0 0-.708z"/>
              </svg>
              <span>{suspendedError}</span>
            </div>
          )}

          {recaptchaSiteKey && (
            <div className="mt-3 d-flex justify-content-start flex-column">
              <ReCAPTCHA
                sitekey={recaptchaSiteKey}
                onChange={(token) => {
                  setCaptchaToken(token || "");
                  setFieldValue("captchaToken", token || "");
                  setFieldTouched("captchaToken", true, false);
                }}
                onExpired={() => {
                  setCaptchaToken("");
                  setFieldValue("captchaToken", "");
                  setFieldTouched("captchaToken", true, false);
                }}
              />
              {errors.captchaToken && touched.captchaToken && (
                <div className="mt-2">
                  <ErrorMessage
                    name="captchaToken"
                    component="div"
                    className="error_text_color"
                  />
                </div>
              )}
            </div>
          )}

          <Button
            className="login-button disable-btn  text-white  w-100 mt-3 p-3 font_14"
            type="submit"
            disabled={!(isValid && dirty) || lockCooldown > 0}
            data-title={
              lockCooldown > 0
                ? `Please wait ${lockCooldown} seconds`
                : !(isValid && dirty)
                  ? "Please fill out all Fields to enable button!"
                  : null
            }
          >
            {lockCooldown > 0 ? `Locked for ${lockCooldown}s` : "Login"}
          </Button>

          <SocialAuth
            handleGoogleSignup={handleGoogleSignup}
            handleMicrosoftSignup={handleMicrosoftSignup}
            isSocialLoading={isSocialLoading}
          />

          {/* <div id="emailHelp" className="text-center mt-4 mt-lg-3 mt-xl-3 ">
            <NavLink to="/signup">
              <span style={{ color: "black" }}>Do You Want To Join Us ?</span>
              <span style={{ color: "#0b58ca", fontWeight: "500" }}>
                {" "}
                SignUp
              </span>
            </NavLink>
          </div> */}

          <div className="text-center mt-lg-1 mt-xl-1 ">
            <NavLink to="/forgot">
              <span style={{ color: "black" }}>Forgot your</span>
              <span style={{ color: "#0b58ca", fontWeight: "500" }}>
                {" "}
                Password
              </span>
            </NavLink>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default LoginForm;
